import { Link } from 'react-router-dom';

import HtmlLink from './html/Link';

/**
 * React Router’s `<Link>` styled just like a Link.
 */
export default HtmlLink.withComponent(Link);
